import React, { Suspense, lazy } from "react";
import { PopupLoader } from "../../notify/PopupLoader";
const Component = lazy(() => import(/* webpackChunkName: "ui-rte" */ "./RichTextEditor"));

/**
 * The editor is loaded on first use (its own chunk)
 * @param fallback – shown while it loads, instead of a loading popup (e.g. the content as RichTextView)
 */
export const RichTextEditor = ({ fallback, ...props }) => {
    return (
        <Suspense fallback={fallback ?? <PopupLoader />}>
            <Component {...props} />
        </Suspense>
    );
};
